import { Fragment, useEffect, useMemo, useState } from "react";
import { Box } from "@material-ui/core";
import { padStart } from "lodash";
import { calculateTimeLeft } from "../app/utils";

interface Props {
  className?: string;
  date: Date | null;
}

const CountdownTimer = ({ date, className }: Props) => {
  const initialTimeLeft = useMemo(() => calculateTimeLeft(date), [date]);

  const [timeLeft, setTimeLeft] = useState(initialTimeLeft);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTimeLeft = calculateTimeLeft(date);
      if (currentTimeLeft === null) {
        clearInterval(interval);
      }
      setTimeLeft(currentTimeLeft);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [date]);

  if (date === null) {
    return <></>;
  }

  const timerComponents =
    timeLeft === null
      ? []
      : Object.keys(timeLeft).map((interval) => {
          if (!timeLeft[interval] && interval !== "minutes" && interval !== "seconds") {
            return "";
          }
          const value = padStart(timeLeft[interval].toString(), 2, "0");
          return (
            <Fragment key={interval}>
              <Box className={className} component="span">
                {value}
              </Box>
              {interval === "seconds" ? "" : ":"}
            </Fragment>
          );
        });
  return <Box component="span">{timerComponents.length ? timerComponents : <span>0:00</span>}</Box>;
};

export default CountdownTimer;
